/**
 * Suggestion Box Component
 *
 * Displays follow-up question suggestions as clickable buttons.
 */

import { LitElement, html, css } from 'lit';
import { baseStyles } from '../styles/shared-styles.js';

/**
 * SuggestionBox - Follow-up question suggestions
 * @element suggestion-box
 * @fires suggestion-click - When a suggestion is clicked
 */
export class SuggestionBox extends LitElement {
    static properties = {
        suggestions: { type: Array }
    };

    static styles = [
        baseStyles,
        css`
            :host {
                display: block;
                width: calc(100% - 40px);
                margin-left: 40px;
            }

            .suggestion-box {
                display: flex;
                flex-direction: column;
                align-items: stretch;
                gap: 8px;
                width: 100%;
            }

            .suggestion-box__options {
                display: flex;
                flex-wrap: wrap;
                gap: 8px;
                width: 100%;
                justify-content: flex-end;
            }

            .suggestion-btn {
                padding: 10px 16px;
                background: white;
                border: 1px solid #E4E4E7;
                border-radius: 20px;
                font-size: 14px;
                font-weight: 500;
                font-family: var(--font-family);
                text-align: left;
                cursor: pointer;
                transition: all 0.2s ease;
                white-space: normal;
                word-wrap: break-word;
            }

            .suggestion-btn:hover {
                background: #f0f0f0;
            }

            .suggestion-btn:active {
                transform: scale(0.98);
            }
        `
    ];

    constructor() {
        super();
        this.suggestions = [];
    }

    render() {
        if (!this.suggestions?.length) return null;

        return html`
            <div class="suggestion-box">
                <div class="suggestion-box__options">
                    ${this.suggestions.map(suggestion => html`
                        <button
                            class="suggestion-btn"
                            @click=${() => this._handleClick(suggestion)}>
                            ${suggestion}
                        </button>
                    `)}
                </div>
            </div>
        `;
    }

    /**
     * Handle suggestion button click
     * @param {string} suggestion - Suggestion text
     */
    _handleClick(suggestion) {
        this.dispatchEvent(new CustomEvent('suggestion-click', {
            detail: { suggestion },
            bubbles: true,
            composed: true
        }));
    }
}

customElements.define('suggestion-box', SuggestionBox);
